export default __webpack_public_path__ + "static/bptw_logo-c1eb97a8f881d49cb076e2ce6caaf7d8.png";